import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import InfoIcon from '@material-ui/icons/Info'
import { isMobile } from 'react-device-detect'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { getCookie } from '../ultils/cookie'

const useStyles = makeStyles({
  confirmRemoveDialog: {
    color: '#474747',
    '& .MuiDialog-paper': {
      padding: '40px 60px',
      minWidth: 500,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  confirmRemoveDialogMobile: {
    color: '#474747',
    '& .MuiDialog-paper': {
      padding: '40px 60px',
      minWidth: '80vw',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  title: {
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    '& svg': {
      color: '#DE3131',
      height: 24,
      width: 24,
      marginRight: 8,
    },
  },
  content: {
    color: '#5E5E5E',
    textAlign: 'center',
    fontSize: 14,
    lineHeight: '22px',
    paddingTop: 20,
    '& span': {
      fontWeight: 600,
    },
  },
  btnGroup: {
    marginTop: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: 14,
  },
  cancelBtn: {
    color: '#5E5E5E',
    backgroundColor: 'transparent',
    marginRight: 50,
    cursor: 'pointer',
  },
  deleteBtn: {
    backgroundColor: '#DE3131',
    padding: '9px 38px',
    color: '#fff',
    cursor: 'pointer',
    borderRadius: 3,
  },
})
interface ConfirmRemoveDialogProps {
  open: boolean
  setOpen: any
  removeData: any
  setRemoveData: any
}

const RemovePortfolioDialog = ({
  open,
  setOpen,
  removeData,
  setRemoveData,
}: ConfirmRemoveDialogProps) => {
  const classes = useStyles()
  const { deleteTicker, state } = useContext(PortfolioContext)

  const handleClose = () => {
    setOpen(false)
    setRemoveData(null)
  }

  const handleDeleteTicker = () => {
    deleteTicker(getCookie('userId'), removeData.ticker)
  }

  return (
    <Dialog
      className={
        isMobile
          ? classes.confirmRemoveDialogMobile
          : classes.confirmRemoveDialog
      }
      onClose={handleClose}
      aria-labelledby=""
      open={open}
    >
      <div className={classes.title}>
        <InfoIcon /> Warning
      </div>
      <div className={classes.content}>
        Are you sure you want to delete <span>{removeData?.proper_name}</span>?
        <br />
        You will not be able view this in your portfolio
        <br />
        once deleted.
      </div>
      <div className={classes.btnGroup}>
        <div onClick={handleClose} className={classes.cancelBtn}>
          Cancel
        </div>
        <div className={classes.deleteBtn} onClick={handleDeleteTicker}>
          Delete
        </div>
      </div>
    </Dialog>
  )
}

export default RemovePortfolioDialog
